<mat-card appearance="outlined">
  @if (isLoading) {
    <mat-progress-bar mode="indeterminate" color="primary" />
  }
  <mat-card-header class="flex-row">
    <mat-card-title>Openers</mat-card-title>
    <div class="text-right flex-1">
      <lib-button icon="perm_device_information" (buttonClick)="onAdd()">Add opener</lib-button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <mat-form-field hintLabel="Min 5 characters" class="example-full-width">
      <mat-label>Filter by MAC</mat-label>
      <input matInput (input)="onChange($event.target['value'])">
    </mat-form-field>
    <table [class.grid-loading]="isLoading" mat-table [dataSource]="devices$ | async">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Serial number </th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
      </ng-container>
      <ng-container matColumnDef="mac">
        <th mat-header-cell *matHeaderCellDef> MAC </th>
        <td mat-cell *matCellDef="let element"> {{ element.attributes.macAddress }} </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          @if (true) {
            <button mat-icon-button color="primary" (click)="onRemove(element)"><mat-icon>delete</mat-icon></button>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['name','mac','actions']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['name','mac','actions'];"></tr>
    </table>
  </mat-card-content>
</mat-card>
